"use client";

import React from "react";

const ButtonAsk = () => {
  return (
    <div>
      {/* Tombol chat melayang */}
      <div className="flex flex-col items-end z-50">
        <a
          href="https://wa.me/6281215636018"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 bg-blue-400 rounded-full cursor-pointer shadow-lg hover:bg-blue-600 transition"
        >
          <img
            src="/img/Wa-Icon.png"
            alt="WhatsApp icon"
            className="w-6 h-6 sm:w-12 sm:h-12"
          />
        </a>
      </div>
    </div>
  );
};

export default ButtonAsk;
